import {
  CONSTRUCTIVE_FEEDBACK_FEEDBACK,
  CONSTRUCTIVE_FEEDBACK_OPTIONS,
  CONSTRUCTIVE_FEEDBACK_QUESTION,
} from '~/pages/communication/constructiveFeedback/libs/components/ConstructiveFeedbackCommunication/constants'
import FeedbackQuestionPage from '~/pages/communication/libs/FeedbackQuestionPage'
import { TPageProps } from '~/shared/types/commonTypes'

const OPTION_I18N_PREFIX =
  'onboarding.communicationConstructiveFeedback.options'
const TITLE_I18N_KEY = 'onboarding.communicationConstructiveFeedback.title'

const ConstructiveFeedbackCommunication = (props: TPageProps) => (
  <FeedbackQuestionPage
    {...props}
    question={CONSTRUCTIVE_FEEDBACK_QUESTION}
    titleI18nKey={TITLE_I18N_KEY}
    optionI18nKeyPrefix={OPTION_I18N_PREFIX}
    options={CONSTRUCTIVE_FEEDBACK_OPTIONS}
    feedback={CONSTRUCTIVE_FEEDBACK_FEEDBACK}
  />
)

export default ConstructiveFeedbackCommunication
